import clsx from 'clsx';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { focusAndSelectElement } from '@/utilities/dom.utilities';
import { TextArea } from '@seeqdev/qomponents';

export type DescriptionClassNames = {
  container?: string;
  editableContainer?: string;
  editableLabel?: string;
  editableValue?: string;
  textArea?: string;
  readonlyContainer?: string;
  readonlyLabel?: string;
  readonlyValue?: string;
  readonlyText?: string;
};

export type DescriptionProps = {
  canWrite: () => boolean;
  originalDesc: string;
  updateDescription: (description: string) => Promise<void>;
  isWorkbookLocked: boolean;
  testId?: string;
  classNames?: DescriptionClassNames;
};

export const Description = ({
  canWrite,
  originalDesc,
  updateDescription,
  isWorkbookLocked,
  testId = 'Description',
  classNames,
}: DescriptionProps) => {
  const { t } = useTranslation();

  const [description, setDescription] = useState(originalDesc);

  useEffect(() => {
    setDescription(originalDesc);
  }, [originalDesc]);

  return (
    <dl data-testid={testId} className={classNames?.container}>
      {canWrite() && (
        <div className={clsx('propList__item', classNames?.editableContainer)} data-testid="descriptionContainer">
          <dt className={clsx('propList__item__name tw:mb-0', classNames?.editableLabel)}>{t('DESCRIPTION')}</dt>
          <dd className={clsx('propList__item__value', classNames?.editableValue)}>
            <TextArea
              extraClassNames={clsx('tw:min-h-sq-18!', classNames?.textArea)}
              id="specDescription"
              testId="specDescription"
              value={description ?? ''}
              onChange={(e) => setDescription(e.target.value)}
              onFocus={focusAndSelectElement}
              onBlur={() => updateDescription(description)}
              rows={4}
              disabled={isWorkbookLocked}
            />
          </dd>
        </div>
      )}
      {!(_.isEmpty(description) || canWrite()) && (
        <div
          className={clsx('propList__item', classNames?.readonlyContainer)}
          data-testid="descriptionDisplayContainer">
          <dt className={clsx('tw:mb-0', classNames?.readonlyLabel)}>{t('DESCRIPTION')}</dt>
          <dd className={clsx('propList__item__value', classNames?.readonlyValue)}>
            <p
              className={clsx('tw:mb-sq-5 tw:whitespace-pre-wrap', classNames?.readonlyText)}
              data-testid="descriptionText">
              {description}
            </p>
          </dd>
        </div>
      )}
    </dl>
  );
};
